import { useScopedSelector } from 'ia-react-core';
import { OnboardingResourceInfo } from '~/components/OnboardingResource';
import { OnboardingData } from '~/interfaces/OnboardingData';
import OnboardingStatus from '~/interfaces/OnboardingStatus';

// Returns true if onboarding (centralization) status is Completed.
export const useIsOnboardingCompleted = (): boolean => {
  const onboarding = useScopedSelector<OnboardingData>(OnboardingResourceInfo.dataDst);
  return onboarding?.status === OnboardingStatus.Completed;
};

export default useIsOnboardingCompleted;
